import { compose, filter, map, prop, propOr, values } from 'ramda';
import { createSelector } from 'reselect';

import { campaignStates } from 'constants/campaigns';

import { NAME } from './constants';

const empty = [];
const getRoot = prop(NAME);
const getCampaignsByIds = compose(prop('byId'), getRoot);

export const getIdsByKeyWindow = createSelector(
	// eslint-disable-next-line no-unused-vars
	(state, keyWindow) => getRoot(state),
	(state, keyWindow) => keyWindow,
	(root, keyWindow) => {
		return propOr(empty, keyWindow)(root);
	},
);

export const getAllCampaigns = () => compose(values, prop('byId'), getRoot);

export const getCampaigns = createSelector(
	// eslint-disable-next-line no-unused-vars
	(state, keyWindow) => getCampaignsByIds(state),
	(state, keyWindow) => getIdsByKeyWindow(state, keyWindow),
	(campaignsByIds, idsByKeyWindows) => {
		return map((id) => campaignsByIds[id])(idsByKeyWindows);
	},
);

export const getRunningCampaigns = createSelector(
	(state, keyWindow) => getCampaigns(state, keyWindow),
	(campaigns) => {
		return filter((c) => c.campaignStateId === campaignStates.RUNNING)(campaigns);
	},
);
